import { subscribe, unsubscribe } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import { useMediator } from '../useMediator';

export const useSubscribers = () => {
  let listSubscribers = [];

  const [getMediator, setMediator] = useMediator();

  const setSub = () => {
    if (listSubscribers.length > 0) return;

    listSubscribers.push(subscribe(way.DRIVE_MAP_CLICK, getMediator().notify));
    listSubscribers.push(
      subscribe(way.DRIVE_MAP_POINT_DRAGEND, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_MAP_POINT_REMOVE, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_MAP_STATIC_POINT_SELECTED, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_LIST_POINT_UPDATE_INDEX, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_LIST_ADD_EMPTY_VIA_POINT, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_LIST_REMOVE_EMPTY_VIA_POINT, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_BUILDER_PART_ACTION, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_BUILDER_TOUR_REVERSE, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_MAP_POINT_SET_TYPE, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.AXIOS_BUILDER_CANCELED_POLY_ID, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_MAP_DRAGED_POINT_MOVED, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_MAP_BREAK_POLY_HERE, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_CHANGE_CURSOR_ICON, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.DRIVE_PREVIEW_POINT_UPDATE, getMediator().notify)
    );

    listSubscribers.push(
      subscribe(way.SAVE_TB_PART_DATA_IN_REDUX, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_MAP_UPLOAD_GPS_DATA, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.MAP_SET_CORREC_POINT_COORD, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(
        way.DRIVE_MAPBUILDER_HIDE_WRONG_ROUTE_POPUP,
        getMediator().notify
      )
    );
    listSubscribers.push(
      subscribe(
        way.DRIVE_BUILDER_MOVE_POINT_CORRECT_PLACE,
        getMediator().notify
      )
    );
    listSubscribers.push(
      subscribe(way.MOVE_POINTS_SHORT_WRONG_DIST_TO_ROUTE, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.CHANGE_CORRECTION_WRONG_ROUTE_STATUS, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.CORRECT_ALL_WRONG_ROUTES_POSITION, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.MAP_EXCHANGE_WITH_NEXT_POINT, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.MAP_AUTOCORRECT_POINT_COORD, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.MAP_DRIVE_GO_TO_PREVIOUS_TOUR_STATE, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.MAP_DRIVE_CLEAR_AUTOCORRECTION_PUPUPS, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.SAVE_TB_UPDATE_ALL_POLYS, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.SAVE_TB_SWITCH_SHAPING_UNPAVED_ROUTES, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_BUILDER_PART_DEVIDE_BY_POINT, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_ADD_POINT_BY_FINGER_DRAW, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_SHOW_RT_POLY, getMediator().notify)
    );
    listSubscribers.push(
      subscribe(way.DRIVE_FIXED_POINTS, getMediator().notify)
    );
    listSubscribers.push(subscribe(way.DRIVE_CLEAR_DATA, getMediator().notify));
  };

  const destroySub = () => {
    listSubscribers.forEach((token) => {
      unsubscribe(token);
    });
    listSubscribers = [];
  };

  return [{ sub: { set: setSub, destroy: destroySub } }, setMediator];
};
